import { Navigate, Route, Routes } from "react-router-dom";
import FSIPage from "./fsi";
import IncOrdersRoutes from "./orders/Routes";
import ProductsPage from "./products";

const IncPages = () => (
  <Routes>
    <Route>
      <Route path="orders/*" element={<IncOrdersRoutes />} />
      <Route path="products" element={<ProductsPage />} />
      <Route path="fsi" element={<FSIPage />} />
      <Route path="*" element={<Navigate to="orders" />} />
    </Route>
  </Routes>
);

export default IncPages;
